import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { DECLARATION_ID_SESSION } from '../constants/AppConstants';
import { SIGN_IN_URL, VOYAGE_CHECK_YOUR_ANSWERS } from '../constants/AppUrlConstants';

const ProtectedRoutes = ({ isPermittedToView }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // NMSW-1577
  const declarationId = (searchParams.get('report') ?? '') || (searchParams.get('declarationId') ?? '');
  const sessDecId = sessionStorage.getItem(DECLARATION_ID_SESSION);
  const url = `${VOYAGE_CHECK_YOUR_ANSWERS}?report=${sessDecId}`;
  useEffect(() => {
    if (
      sessDecId
      && declarationId === sessDecId
      && (location.pathname + location.search) !== url
    ) {
      navigate(url, { replace: true });
    }
  }, [declarationId, sessDecId, location, navigate, url]);

  return (
    isPermittedToView ? <Outlet /> : <Navigate to={SIGN_IN_URL} state={{ redirectURL: location }} replace />
  );
};

export default ProtectedRoutes;

ProtectedRoutes.propTypes = {
  isPermittedToView: PropTypes.bool.isRequired,
};
